import ContactAvatar from 'components/crm/ContactAvatar'
import AvatarEditField from 'components/crm/AvatarEditField'

import useSelectCustomFieldValueForKeyAndType from '../useSelectCustomFieldValueForKeyAndType'

export default function ContactAvatarEditField() {
  const avatarUrl = useSelectCustomFieldValueForKeyAndType(
    'contact_avatar',
    'CONTACT',
    'url'
  )
  const email = useSelectCustomFieldValueForKeyAndType(
    'contact_email',
    'CONTACT'
  )
  return (
    <AvatarEditField
      as={ContactAvatar}
      email={email}
      fallback={
        <ContactAvatar
          className="DisplayedAvatar"
          email={email}
          size={80}
          src={avatarUrl}
        />
      }
      name="contact_avatar"
      size={80}
      url={avatarUrl}
    />
  )
}
